import { render, staticRenderFns } from "./Inconsistences.vue?vue&type=template&id=2f58d6e8&"
import script from "./Inconsistences.vue?vue&type=script&lang=js&"
export * from "./Inconsistences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports